import { newAnswer } from "../types/Answer";
import QuestionDetails from "../components/thread/QuestionDetails";
import YourAnswer from "../components/thread/YourAnswer";
import AnswersList from "../components/thread/AnswersList";
import { getIdParam } from "../../common/utils/helper";
import { useAuth } from "../contexts/auth.context";
import { useGetQuestionQuery } from "../../features/api/questionSlice";
import { useGetAnswersQuery, useCreateAnswerMutation } from "../../features/api/answerSlice";

import React from "react";
import { Box, Container, Grid, Toolbar } from "@mui/material";

const Thread: React.FC = () => {
    /*
        Structure: 
        - QuestionDetails
        - YourAnswer
        - AnswersList (including AI answer)
    */

    const id = getIdParam();

    // get current user from context
    const { user } = useAuth();
    const { data: question, isLoading: loadingQuestion, isSuccess: successQuestion } = useGetQuestionQuery(id);
    const { data: answers, isLoading: loadingAnswers, isSuccess: successAnswers } = useGetAnswersQuery(id);
    const [createAnswer, { isLoading: loadingCreateAnswer }] = useCreateAnswerMutation();
    const isLoading = loadingAnswers || loadingQuestion;
    const isSuccess = successAnswers && successQuestion;

    async function handleAnswerSubmit(body: string) {
        const ans = newAnswer(user, question!.id, body);

        // Submit answer through api
        if (!loadingCreateAnswer) {
            try {
                await createAnswer(ans).unwrap();
            } catch (error) {
                console.log(error);
            }
        }
    }

    if (isLoading) {
        return <div></div>;
    } else if (!isSuccess || question === undefined || answers === undefined) {
        return <div>Error</div>;
    }

    return (
        <Box
            component="main"
            sx={{
                backgroundColor: (theme) =>
                    theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900],
                flexGrow: 1,
                height: "100vh",
                overflow: "auto",
            }}
        >
            <Toolbar />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                    {/* Question details */}
                    <Grid item xs={12}>
                        <QuestionDetails question={question} />
                    </Grid>

                    {/* Your answer */}
                    <Grid item xs={12}>
                        <YourAnswer onAnswerSubmit={handleAnswerSubmit} />
                    </Grid>

                    {/* Answers List */}
                    <Grid item xs={12}>
                        <AnswersList answers={answers} question={question} />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Thread;
